import { PromoCodeVM } from "./promo-code-vm";

export class ValidatePromoCodeVM {
  promoCode: PromoCodeVM;
  promoCodeIsValid: boolean;
}
